import { render, staticRenderFns } from "./ObjectStoreRestrictionSpan.vue?vue&type=template&id=828de07a&scoped=true&"
import script from "./ObjectStoreRestrictionSpan.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ObjectStoreRestrictionSpan.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ObjectStoreRestrictionSpan.vue?vue&type=style&index=0&id=828de07a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "828de07a",
  null
  
)

export default component.exports